/*🤫
🤫
🤫
🤫
🤫
🤫*/

export * from "./globals/device";
export const {
  device,
  device: {
    Hybrid,
    Orientation,
    breakpoint,
    browser,
    hybrid,
    isTouchable,
    orientation,
    os,
    screen,
    type,
  },
} = window.o_global;
